import { render, staticRenderFns } from "./po_component_section.vue?vue&type=template&id=66a3ce40&"
import script from "./po_component_section.vue?vue&type=script&lang=js&"
export * from "./po_component_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports